<template>
    <div class="app-inner fixed fixed-head-3">
        <!--/-->
        <div class="app-head">
            <common-header></common-header>
            <common-nav></common-nav>
            <el-row class="c_nav_menu_wrapper c_subnav">
                <el-menu :default-active="getActiveIndex()" class="c_nav_menu" mode="horizontal" router>
                    <el-menu-item index="/inventory/examination">库存体检</el-menu-item>
                    <el-menu-item index="/inventory/forecast">库存预测</el-menu-item>
                    <el-menu-item index="/inventory/search">库存查询</el-menu-item>
                    <el-menu-item index="/inventory/monitor-list">监控名单</el-menu-item>
                </el-menu>
            </el-row>
        </div>

        <!--/-->
        <div class="app-body">
            <my-bscroll>
                <keep-alive>
                    <router-view></router-view>
                </keep-alive>
            </my-bscroll>
        </div>
    </div>
</template>

<script>
export default {
    data :function() {
        return {
            getActiveIndex:function(){
                let path = this.$route.path;
                if(path.startsWith('/inventory/examination')) return '/inventory/examination';
                if(path.startsWith('/inventory/search')) return '/inventory/search';
                else return path;
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/inventory/_layout.vue